import React, { FC } from 'react';
import { Alert } from '@kontentino/ui';
import { useTranslation } from 'react-i18next';

type Props = {};

const ReportFailedToBuildMessage: FC<Props> = (props) => {
  const { t } = useTranslation();

  return (
    <div className="tw-p-8">
      <Alert variant="danger">
        {t('pdfReports.reportFailedToBuild.message')}
        <br />
        {t('pdfReports.reportFailedToBuild.retryMessage')}
      </Alert>
    </div>
  );
};

export default ReportFailedToBuildMessage;
